export default defineNuxtPlugin((nuxtApp) => {
  // @ts-expect-error global property
  const experiments = window.__EXPERIMENTS__ || {}
  nuxtApp.provide('experiments', experiments)
})
